import * as React from 'react';
import { ContentWrapper } from '../../uiComponents/layout/ContentWrapper';
import { KonkurrenceMedTilmeldinger } from '../../models/KonkurrenceMedTilmeldinger';
import TilmeldingKonkurrenceCard from './TilmeldingKonkurrenceCard';
import { StepsWrapper, Step } from '../../uiComponents/Steps';
import { Header } from '../../uiComponents/layout/Header';
import { createApiCaller } from '../../infrastructure/api/ApiFactory';
import { Spinner } from '../../uiComponents/Spinner';
import { EmptyState } from '../../uiComponents/EmptyState';

export interface TilmeldingVaelgKonkurrenceProps {
}

export interface TilmeldingVaelgKonkurrenceState {
    konkurrencer?: KonkurrenceMedTilmeldinger[];
}

class TilmeldingVaelgKonkurrence extends React.Component<TilmeldingVaelgKonkurrenceProps, TilmeldingVaelgKonkurrenceState> {
    constructor(props: TilmeldingVaelgKonkurrenceProps) {
        super(props);
        this.state = { konkurrencer: undefined };
    }

    componentDidMount() {
        let konkurrencerPromise = createApiCaller().getKonkurrencerMedTilmeldinger();
        let self = this;
        konkurrencerPromise.then(konkurrencer => self.setState({ konkurrencer: konkurrencer }));
    }

    render() {
        if (this.state.konkurrencer === undefined) {
            return <Spinner />;
        } else {
            let konkurrenceCards = this.state.konkurrencer.map((k, i) =>
                (
                    <TilmeldingKonkurrenceCard konkurrence={k} key={i} />
                )
            );
            const ingenKonkurrencer = (
                <EmptyState
                    header='Der er ingen konkurrencer i din kommune i øjeblikket'
                    subText='Bed eventuelt din naturfagskoordinator om at kontakte Naturvidenskabernes Hus for oprettelse af konkurrencer.'
                />
            );
            return (
                <ContentWrapper>
                    <StepsWrapper>
                        <Step href='/tilmelding/login' label='1' state='done'>
                            Login
                        </Step>
                        <Step href='/tilmelding/vaelg-konkurrence' label='2' state='active'>
                            Vælg konkurrence
                        </Step>
                        <Step href='#' label='3' state='ahead'>
                            Tilmeld hold
                        </Step>
                        <Step href='#' label='4' state='ahead'>
                            Bekræft
                        </Step>
                    </StepsWrapper>

                    {konkurrenceCards.length > 0 &&
                        <div>
                            <Header type='h2' marginBottom={true}>Vælg konkurrence</Header>
                            {konkurrenceCards}
                        </div>
                    }
                    {konkurrenceCards.length === 0 && ingenKonkurrencer}
                </ContentWrapper>
            );
        }
    }
}

export default TilmeldingVaelgKonkurrence;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/tilmelding/TilmeldingVaelgKonkurrence.tsx